export default __webpack_public_path__ + "static/media/logout_icon.d223d84a.svg";